import React from "react";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { Typography, Button } from "@picklebet/ui";
import { telemetry } from "@/utilities/telemetry";

type ExistingAccountPromptProps = {
  className?: string;
  isEmailTaken?: boolean;
  includeBrand?: boolean;
};

const ExistingAccountPrompt = ({
  className,
  isEmailTaken = false,
  includeBrand = false,
}: ExistingAccountPromptProps) => {
  const setModal = useShellStore((state) => state.setModal);

  return (
    <Typography className={className} component={`span`} noSpacing>
      Already have {includeBrand ? "a Picklebet" : "an"} account?{" "}
      <Button
        className={className}
        variant={"link"}
        onClick={() => {
          setModal("signIn");
          telemetry.logInClickedInSignUp({
            emailAlreadyExists: isEmailTaken,
          });
        }}
      >
        Log in
      </Button>
    </Typography>
  );
};

export { ExistingAccountPrompt };
